import { type Bet } from '../types';

export const countUniqueBookiesFromOdds = (bets: Bet[]) => {
  const uniqueBookies: string[] = [];

  bets.forEach(bet => {
    bet.odds.forEach(odd => {
      const code = odd.bookmakerCode;
      if (!uniqueBookies.includes(code)) uniqueBookies.push(code);
    });
  });

  return uniqueBookies.length;
};
